var TriggerPageOpenStrategy = /** @class */ (function () {
    function TriggerPageOpenStrategy() {
        this._callback = null;
        this._registerId = null;
    }
    TriggerPageOpenStrategy.prototype.register = function (callback, timeout) {
        this._callback = callback;
        this._registerId = window.setTimeout(function () {
            callback();
        }, timeout + this.getRandomDelay());
    };
    TriggerPageOpenStrategy.prototype.destroy = function (timeout) {
        var _this = this;
        if (isNaN(timeout)) {
            clearTimeout(this._registerId);
            return;
        }
        setTimeout(function () {
            _this._callback();
        }, timeout + this.getRandomDelay());
    };
    TriggerPageOpenStrategy.prototype.getRandomDelay = function () {
        // Случайная задержка для псевдоротации виджетов с одинаковым таймаутом
        return Math.floor(Math.random() * 200);
    };
    return TriggerPageOpenStrategy;
}());
export { TriggerPageOpenStrategy };
